<div class="list-content-wrapper">
  <div #listContent class="list-content">
    <!-- fixed to infinite list entry -->
    <ng-container #entry></ng-container>
  </div>
</div>
